import { ThreeView } from "./View3dWebCad";
import { webcadDefines } from '../webcad';

export class ObjectType {
    private static ModelType = (obj: THREE.Object3D) => {
        if (obj == null || obj.userData.modelInfo == null) return undefined;
        return obj.userData.modelInfo.typeExtras;
    };

    // 家具
    public static isFurniture = (obj: THREE.Object3D) => ObjectType.ModelType(obj) == webcadDefines.ExtrasType.FUR;
    // 住設
    public static isEquipment = (obj: THREE.Object3D) => ObjectType.ModelType(obj) == webcadDefines.ExtrasType.EQU;
    // 外構
    public static isExterior = (obj: THREE.Object3D) => ObjectType.ModelType(obj) == webcadDefines.ExtrasType.EXT;

    public static isFitting = (obj: THREE.Object3D) => {
        const type = ObjectType.ModelType(obj);
        return type == webcadDefines.ExtrasType.DOOR
            || type == webcadDefines.ExtrasType.WIN
            || type == webcadDefines.ExtrasType.SHUTTER;
    }

    //天井照明
    public static isCeillingLight = (obj: THREE.Object3D) => ObjectType.ModelType(obj) == webcadDefines.ExtrasType.LIGHT;

    // 壁
    public static isWall = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KABE;
    // 腰壁
    public static isKosiWall = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KOSI;

    // 内壁
    public static isInnerWall = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.INNERWALL;

    // 外壁
    public static isOuterWall = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.OUTWALL;

    // 下がり壁
    public static isFalling = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.FALLING;;
    public static isFallingWall = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.FALLINGWALL;

    // 天井
    public static isCeiling = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasType.CEILING;
    public static isCeiling_ = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.CEILING;

    // 梁
    public static isGirder = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasType.GIRDER;
    public static isGirder_ = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.GIRDER;
    
    // 床
    public static isFloor = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasType.FLOOR;
    public static isFloor_ = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.FLOOR;

    // 框
    public static isKamachi = (obj: THREE.Object3D) : boolean => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KAMACHI && obj.userData.sub_type == webcadDefines.ExtrasType.KAMACHI;
    // public static isKamachi = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KAMACHI;

    //見積もりリスト選択用
    // 床
    public static isFloorFloor = (obj: THREE.Object3D) => {
        const data = obj.userData;
        return data.type && data.type == webcadDefines.ExtrasType.FLOOR && data && data.sub_type == webcadDefines.ExtrasSubType.FLOOR;
    }
    // 土間
    public static isFloorEntrance = (obj: THREE.Object3D) => {
        const data = obj.userData;
        return data.type && data.type == webcadDefines.ExtrasType.FLOOR && data && data.sub_type == webcadDefines.ExtrasSubType.ENTRANCE;
    }
    
    public static isMitumoriFloor = (obj: THREE.Object3D) => {
        return this.isFloorFloor(obj) || this.isFloorEntrance(obj);
    }

    // 敷地
    public static isSite = (obj: THREE.Object3D) => {
        return obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.GROUND && obj.userData.sub_type == webcadDefines.ExtrasSubType.GROUND;
    };

    // ピン
    public static isPin = (obj: THREE.Object3D) => {
        return ObjectType.ModelType(obj) == webcadDefines.ExtrasType.PIN;
    }

    // カメラピン
    public static isCameraPin = (obj: THREE.Object3D) => {
        return ObjectType.ModelType(obj) == webcadDefines.ExtrasType.CAMERA_PIN;
    }

    private static isSelectableItems(object: THREE.Object3D): boolean {
        return ObjectType.isFurniture(object)
            || ObjectType.isEquipment(object)
            || ObjectType.isExterior(object)
            || ObjectType.isCeillingLight(object)
            || ObjectType.isFitting(object)
            || ObjectType.isPin(object)
            || ObjectType.isCameraPin(object)
    }

    // 対象の家具・住設・外構・ピンを取得
    public static getItem_(groups: THREE.Group[], object: THREE.Object3D) {
        if (object == null) return null;
        if (object.userData.type) return null; // 家の部品
        if (object.userData.modelInfo && !(ObjectType.isSelectableItems(object))) return null; // 選択可能アイテム以外は早めにreturn

        const index = groups.findIndex((obj) => obj.uuid == object.uuid);
        if (index == -1) return ObjectType.getItem_(groups, object.parent);
        return groups[index];
    }

    public static getItem(object: THREE.Object3D) {
        return ObjectType.getItem_([...ThreeView.get().wcItemmgr.furnitureObjects, ...ThreeView.get().wcItemmgr.fittings], object);
    }

    // 家具・住設・外構・ピンの部品かどうか（選択可能なアイテムか）
    public static isItemSelected(obj: THREE.Object3D): boolean {
        const object = ObjectType.getItem(obj);
        if (object == null) return false;
        return ObjectType.isSelectableItems(object);
    }
}